<div class="chart-card chart-small">
  <div class="chart-header">
    <h5>Savings</h5>
  </div>

  <div class="savings-chart-content">
    <div class="donut-charts-container">

      <!-- PDA -->
      <div class="donut-chart-section savings-clickable" (click)="openSavingsPopup('pda')">
        <div class="donut-chart">
          <svg width="180" height="180" viewBox="0 0 180 180">
            <circle class="donut-ring" cx="90" cy="90" r="65" fill="transparent"></circle>
            <circle class="donut-segment-pda" cx="90" cy="90" r="65" fill="transparent"
              [style.stroke-dasharray]="getPDASavingsStrokeDashArray()" [style.stroke-dashoffset]="0"></circle>
          </svg>
          <div class="donut-center">
            <div class="donut-percentage">64%</div>
          </div>
        </div>
        <div class="donut-bottom-label">
          <span class="donut-label-text">PDA</span>
          <mat-icon class="click-info-icon">open_in_new</mat-icon>
        </div>
      </div>

      <!-- MIDDLE -->
      <div class="middle-savings-section savings-clickable" (click)="openSavingsPopup('overall')">
        <div class="savings-item-row">
          <span class="savings-label">Overall Savings:</span>
          <span class="savings-value">${{ savingsData.overallSavingsAmount | number:'1.2-2' }}</span>
        </div>

        <div class="savings-item-row">
          <div class="savings-label-with-dot">
            <div class="savings-color-dot pda-dot"></div>
            <span class="savings-label">PDA Savings:</span>
          </div>
          <span class="savings-value">${{ savingsData.pdaSavingsAmount | number:'1.2-2' }}</span>
        </div>

        <div class="savings-item-row">
          <div class="savings-label-with-dot">
            <div class="savings-color-dot fda-dot"></div>
            <span class="savings-label">FDA Savings:</span>
          </div>
          <span class="savings-value">${{ savingsData.fdaSavingsAmount | number:'1.2-2' }}</span>
        </div>

        <div class="savings-item-row">
          <span class="savings-label">PDA Estimated:</span>
          <span class="savings-value">${{ savingsData.pdaEstimatedBudget | number:'1.0-0' }}</span>
        </div>

        <div class="savings-item-row">
          <span class="savings-label">FDA Actual Billed:</span>
          <span class="savings-value">${{ savingsData.fdaUtilizedAmount | number:'1.0-0' }}</span>
        </div>

        <div class="middle-click-hint">
          <mat-icon>touch_app</mat-icon>
          Click to view PDA & FDA breakdown
        </div>
      </div>

      <!-- FDA -->
      <div class="donut-chart-section savings-clickable" (click)="openSavingsPopup('fda')">
        <div class="donut-chart">
          <svg width="180" height="180" viewBox="0 0 180 180">
            <circle class="donut-ring" cx="90" cy="90" r="65" fill="transparent" stroke="var(--color-action)" stroke-width="35"></circle>
            <circle class="donut-segment-fda" cx="90" cy="90" r="65" fill="transparent"
              [style.stroke-dasharray]="getFDASavingsStrokeDashArray()" [style.stroke-dashoffset]="0"></circle>
          </svg>
          <div class="donut-center">
            <div class="donut-percentage">36%</div>
          </div>
        </div>
        <div class="donut-bottom-label">
          <span class="donut-label-text">FDA</span>
          <mat-icon class="click-info-icon">open_in_new</mat-icon>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- =====================================================
     SAVINGS INSIGHTS POPUP
===================================================== -->
<div class="savings-modal-backdrop" *ngIf="showSavingsPopup" (click)="closeSavingsPopup()">
  <div class="savings-modal" #modalContainer (click)="$event.stopPropagation()">
    
    <!-- Header -->
    <div class="savings-modal-header">
      <div class="modal-title-section">
        <div class="modal-title-icon">
          <mat-icon>auto_awesome</mat-icon>
        </div>
        <div>
          <h2>{{ getSavingsPopupTitle() }}</h2>
          <span>Disbursement savings performance measured from PDA estimates to final FDA bills</span>
        </div>
      </div>
      <button class="modal-close-btn" (click)="closeSavingsPopup()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- =================================================
         TOP KPI GRID
    ================================================== -->
    <div class="modal-kpi-grid">
      <div class="modal-kpi total-saving">
        <div class="modal-kpi-icon">
          <mat-icon>savings</mat-icon>
        </div>
        <div>
          <span>Total Savings (Delta)</span>
          <strong>+${{ getPopupTotalSaving() | number:'1.2-2' }}</strong>
          <em>{{ getSavingsPercentage() }}% saved against PDA</em>
        </div>
      </div>

      <div class="modal-kpi">
        <div class="modal-kpi-icon pda-kpi">
          <mat-icon>account_balance_wallet</mat-icon>
        </div>
        <div>
          <span>FDA (Actual Spent)</span>
          <strong>${{ getActualDisbursement() | number:'1.2-2' }}</strong>
          <small>PDA: ${{ getInitialDisbursement() | number:'1.2-2' }}</small>
        </div>
      </div>

      <div class="modal-kpi">
        <div class="modal-kpi-icon fda-kpi">
          <mat-icon>directions_boat</mat-icon>
        </div>
        <div>
          <span>Total Port Calls</span>
          <strong>{{ savingsData.totalPortCalls }} Calls</strong>
          <em>{{ savingsData.budgetUtilizedPercentage }}% PDA Utilized</em>
        </div>
      </div>

      <div class="modal-kpi">
        <div class="modal-kpi-icon tat-kpi">
          <mat-icon>trending_up</mat-icon>
        </div>
        <div>
          <span>Efficiency Rate</span>
          <strong>{{ savingsData.efficiencyRate }}%</strong>
          <em>Avg FDA: ${{ savingsData.avgDisbursementPerCall | number:'1.0-0' }}</em>
        </div>
      </div>
    </div>

    <!-- =================================================
         OVERALL DISBURSEMENT BREAKDOWN CARD
    ================================================== -->
    <div class="modal-section">
      <div class="modal-section-title">
        <div>
          <h3>Overall Disbursement Calculation</h3>
          <span>Breakdown of total PDA estimates vs actual FDA billing across all port calls</span>
        </div>
      </div>

      <div class="disbursement-breakdown-card">
        <div class="breakdown-row">
          <span class="b-label">PDA (Estimated)</span>
          <span class="b-value">${{ getInitialDisbursement() | number:'1.2-2' }}</span>
        </div>
        <div class="breakdown-row">
          <span class="b-label">FDA (Actual Spent)</span>
          <span class="b-value">${{ getActualDisbursement() | number:'1.2-2' }}</span>
        </div>
        <div class="breakdown-row highlight-row">
          <span class="b-label">Total Savings Realized</span>
          <span class="b-value positive">+${{ getPopupTotalSaving() | number:'1.2-2' }} (+{{ getSavingsPercentage() }}%)</span>
        </div>
        <div class="breakdown-divider"></div>
        <div class="breakdown-grid">
          <div class="sub-metric">
            <span class="s-label">1D Savings Delta</span>
            <span class="s-value positive">+${{ savingsData.oneDayDelta || 0 }} (+{{ savingsData.oneDayDeltaPercentage || 0 }}%)</span>
          </div>
          <div class="sub-metric">
            <span class="s-label">Avg. FDA / Port Call</span>
            <span class="s-value">${{ savingsData.avgDisbursementPerCall || 0 | number:'1.2-2' }}</span>
          </div>
          <div class="sub-metric">
            <span class="s-label">Active Port Calls Total</span>
            <span class="s-value">${{ savingsData.shortTermPortCallsAmount || 0 | number:'1.0-0' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- =================================================
         CARDS (PDA & FDA)
    ================================================== -->
    <div class="modal-section">
      <div class="modal-section-title">
        <div>
          <h3>How this saving comes & Utilization Breakdown</h3>
          <span>Click a card below to view detailed disbursement line items</span>
        </div>
      </div>

      <div class="saving-source-grid two-cards-grid">

        <!-- SOURCE 1: PDA Tariff Negotiation -->
        <div
          class="saving-source-card"
          [class.active]="selectedSavingSource === 'pda_negotiation'"
          (click)="selectSavingSource('pda_negotiation')"
        >
          <div class="source-number pda-source">01</div>
          <div class="source-content">
            <h4>PDA Tariff & Rate Negotiation</h4>
            <p><strong>Where it comes from:</strong> Negotiating initial agent pre-advances prior to port entry.</p>
            
            <div class="utilization-metrics">
              <div class="u-row">
                <span>PDA Estimated:</span>
                <strong>${{ savingsData.pdaTariffBudget | number:'1.0-0' }}</strong>
              </div>
              <div class="u-row">
                <span>FDA Spent:</span>
                <strong>${{ savingsData.pdaTariffFDAUtilized | number:'1.0-0' }}</strong>
              </div>
            </div>

            <div class="source-bottom">
              <span><mat-icon>payments</mat-icon> Savings Realized:</span>
              <strong class="positive">+${{ savingsData.pdaTariffSavings | number:'1.0-0' }}</strong>
            </div>
          </div>
          <mat-icon class="source-arrow">chevron_right</mat-icon>
        </div>

        <!-- SOURCE 2: FDA Tariff Negotiation -->
        <div
          class="saving-source-card"
          [class.active]="selectedSavingSource === 'fda_negotiation'"
          (click)="selectSavingSource('fda_negotiation')"
        >
          <div class="source-number fda-source">02</div>
          <div class="source-content">
            <h4>FDA Tariff & Rate Negotiation</h4>
            <p><strong>Where it comes from:</strong> Auditing and negotiating final tugboat, pilot, berth charges against vessel logs.</p>
            
            <div class="utilization-metrics">
              <div class="u-row">
                <span>PDA Estimated:</span>
                <strong>${{ savingsData.fdaVoucherBudget | number:'1.0-0' }}</strong>
              </div>
              <div class="u-row">
                <span>FDA Spent:</span>
                <strong>${{ savingsData.fdaVoucherUtilized | number:'1.0-0' }}</strong>
              </div>
            </div>

            <div class="source-bottom">
              <span><mat-icon>receipt_long</mat-icon> Savings Realized:</span>
              <strong class="positive">+${{ savingsData.fdaVoucherSavings | number:'1.0-0' }}</strong>
            </div>
          </div>
          <mat-icon class="source-arrow">chevron_right</mat-icon>
        </div>

      </div>
    </div>

    <!-- =================================================
         BOTTOM TABLE SECTION (Hidden until a card is clicked)
    ================================================== -->
    <div class="modal-section table-section" #tableSection *ngIf="selectedSavingSource">
      <div class="modal-section-title table-header-flex">
        <div>
          <h3>{{ selectedSavingSource === 'pda_negotiation' ? 'PDA Tariff & Rate Negotiation Details' : 'FDA Tariff & Rate Negotiation Details' }}</h3>
          <span>Showing detailed port call records ({{ getFilteredTableData().length }} total records)</span>
        </div>
        <button class="close-table-btn" (click)="closeTable()">
          <mat-icon>close</mat-icon>
          Close Table
        </button>
      </div>

      <div class="table-scroll-container" [class.scrollable]="showAllRows">
        <table class="savings-detail-table">
          <thead>
            <tr>
              <th class="text-center">View</th>
              <th>Vessel Name</th>
              <th>Port</th>
              <th>Arrival Date</th>
              <th>{{ selectedSavingSource === 'pda_negotiation' ? 'Initial PDA' : 'Initial FDA' }}</th>
              <th>{{ selectedSavingSource === 'pda_negotiation' ? 'Negotiated PDA' : 'Negotiated FDA' }}</th>
              <th>Savings</th>
              <th>Disbursement ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of getDisplayedTableData()">
              <td class="text-center">
                <button class="icon-btn" title="View details">
                  <mat-icon class="table-eye-icon">visibility</mat-icon>
                </button>
              </td>
              <td class="vessel-cell">{{ row.vesselName }}</td>
              <td>{{ row.port }}</td>
              <td>{{ row.arrivalDate }}</td>
              <td>${{ row.initialAmount | number:'1.2-2' }}</td>
              <td>${{ row.negotiatedAmount | number:'1.2-2' }}</td>
              <td class="positive-text">+${{ row.savings | number:'1.2-2' }}</td>
              <td><span class="disbursement-badge">{{ row.disbursementId }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- View More Toggle -->
      <div class="view-more-wrapper" *ngIf="getFilteredTableData().length > 10">
        <button class="view-more-btn" (click)="toggleViewMore()">
          <mat-icon>{{ showAllRows ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ showAllRows ? 'Show Less' : 'Click to View More (' + (getFilteredTableData().length - 10) + ' remaining) & Scroll' }}
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="savings-modal-footer">
      <div>
        <mat-icon>info</mat-icon>
        Total Savings ($4,995.00) = Total PDA Estimated ($124,995.00) − Total FDA Spent ($120,000.00)
      </div>

      <div class="footer-actions">
        <!-- Back to Top Button -->
        <button type="button" class="back-to-top-btn" *ngIf="selectedSavingSource" (click)="scrollToTop()">
          <mat-icon>arrow_upward</mat-icon>
          Go to Top
        </button>
        <button mat-raised-button color="primary" (click)="closeSavingsPopup()">Done</button>
      </div>
    </div>

  </div>
</div>